{
  "title": "Heal",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level evocation",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Choose a creature that you can see within range. A surge of positive energy washes through the creature, causing it to regain 70 hit points. The spell also ends blindness, deafness, and any diseases affecting the target. This spell has no effect on constructs or undead.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, the amount of healing increases by 10 for each slot level above 6th."
  ],
  "spellLists": ["cleric", "druid"]
}
